import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import SignatureSettings from '../components/SignatureSettings';
import EmailAccounts from '../components/EmailAccounts';
import { messagingAPI, configAPI } from '../services/api';
import './Settings.css';

function Settings() {
  const [whatsappStatus, setWhatsappStatus] = useState({ isReady: false, qrCode: null });
  const [telegramStatus, setTelegramStatus] = useState({ isReady: false });
  const [telegramConfig, setTelegramConfig] = useState({
    botToken: '',
    chatId: ''
  });
  const [testTelegram, setTestTelegram] = useState({
    message: ''
  });

  useEffect(() => {
    checkStatuses();
    loadConfig();
  }, []);

  const checkStatuses = async () => {
    try {
      const [whatsapp, telegram] = await Promise.all([
        messagingAPI.whatsapp.getStatus(),
        messagingAPI.telegram.getStatus()
      ]);

      setWhatsappStatus(whatsapp.data.data);
      setTelegramStatus(telegram.data.data);
    } catch (error) {
      console.error('Durumlar kontrol edilemedi:', error);
    }
  };

  const loadConfig = async () => {
    try {
      const response = await configAPI.getConfig();
      const config = response.data.data;

      if (config.telegram) {
        setTelegramConfig({
          botToken: config.telegram.botToken || '',
          chatId: config.telegram.chatId || ''
        });
      }

    } catch (error) {
      console.error('Yapılandırma yüklenemedi:', error);
    }
  };

  const handleInitializeWhatsApp = async () => {
    try {
      await messagingAPI.whatsapp.initialize();
      alert('WhatsApp başlatılıyor. QR kodu taramak için durumu kontrol edin.');
      setTimeout(() => checkStatuses(), 2000);
    } catch (error) {
      alert('WhatsApp başlatılamadı: ' + error.response?.data?.message);
    }
  };

  const handleLogoutWhatsApp = async () => {
    try {
      await messagingAPI.whatsapp.logout();
      alert('WhatsApp çıkış yapıldı');
      checkStatuses();
    } catch (error) {
      alert('WhatsApp çıkış yapılamadı: ' + error.response?.data?.message);
    }
  };

  const handleSaveTelegramConfig = async (e) => {
    e.preventDefault();
    try {
      await configAPI.updateTelegram(telegramConfig);
      alert('Telegram yapılandırması kaydedildi!');
      checkStatuses();
    } catch (error) {
      alert('Telegram yapılandırması kaydedilemedi: ' + error.response?.data?.message);
    }
  };

  const handleSendTestTelegram = async (e) => {
    e.preventDefault();
    try {
      await configAPI.testTelegram(testTelegram);
      alert('Test Telegram mesajı gönderildi!');
      setTestTelegram({ message: '' });
    } catch (error) {
      alert('Test Telegram mesajı gönderilemedi: ' + error.response?.data?.message);
    }
  };

  return (
    <Layout>
      <div className="settings">
        <h1>Ayarlar</h1>

        <EmailAccounts />

        <SignatureSettings />

        <div className="settings-section">
          <h2>WhatsApp Durumu</h2>
          <div className="service-status">
            <div className="status-indicator">
              <span className={`status-dot ${whatsappStatus.isReady ? 'active' : 'inactive'}`}></span>
              <span>{whatsappStatus.isReady ? 'Bağlı' : 'Bağlı Değil'}</span>
            </div>

            {!whatsappStatus.isReady && (
              <button className="btn-primary" onClick={handleInitializeWhatsApp}>
                WhatsApp'ı Başlat
              </button>
            )}

            {whatsappStatus.isReady && (
              <button className="btn-danger" onClick={handleLogoutWhatsApp}>
                Çıkış Yap
              </button>
            )}
          </div>

          {whatsappStatus.qrCode && (
            <div className="qr-code-container">
              <p>WhatsApp Web QR Kodunu Tarayın:</p>
              <div className="qr-code">
                <img src={whatsappStatus.qrCode} alt="WhatsApp QR Code" style={{maxWidth: '300px'}} />
              </div>
            </div>
          )}
        </div>

        <div className="settings-section">
          <h2>Telegram Ayarları</h2>
          <div className="service-status">
            <div className="status-indicator">
              <span className={`status-dot ${telegramStatus.isReady ? 'active' : 'inactive'}`}></span>
              <span>{telegramStatus.isReady ? 'Yapılandırılmış' : 'Yapılandırılmamış'}</span>
            </div>
          </div>

          <form onSubmit={handleSaveTelegramConfig} className="config-form">
            <div className="form-group">
              <label>Bot Token</label>
              <input
                type="text"
                value={telegramConfig.botToken}
                onChange={(e) => setTelegramConfig({ ...telegramConfig, botToken: e.target.value })}
                placeholder="1234567890:ABCdefGHIjklMNOpqrsTUVwxyz"
                required
              />
              <small>Bot Token almak için @BotFather'a /newbot yazın</small>
            </div>

            <div className="form-group">
              <label>Chat ID</label>
              <input
                type="text"
                value={telegramConfig.chatId}
                onChange={(e) => setTelegramConfig({ ...telegramConfig, chatId: e.target.value })}
                placeholder="123456789"
                required
              />
              <small>Chat ID'nizi öğrenmek için @userinfobot kullanın</small>
            </div>

            <button type="submit" className="btn-primary">Telegram Ayarlarını Kaydet</button>
          </form>

          {telegramStatus.isReady && (
            <div className="test-section">
              <h3>Test Mesajı Gönder</h3>
              <form onSubmit={handleSendTestTelegram}>
                <div className="form-group">
                  <label>Mesaj</label>
                  <textarea
                    value={testTelegram.message}
                    onChange={(e) => setTestTelegram({ message: e.target.value })}
                    placeholder="Test mesajınız..."
                    required
                    rows="3"
                  />
                </div>
                <button type="submit" className="btn-primary">Test Mesajı Gönder</button>
              </form>
            </div>
          )}
        </div>

      </div>
    </Layout>
  );
}

export default Settings;